import { CLEAR_NETWORK_GROUP } from 'actions';

export default function clearNetworkGroup() {
  return (dispatch) => dispatch({ type: CLEAR_NETWORK_GROUP });
}
